'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

/**
 * CSS reset for Brandfolder.
 *
 * Inspiration:
 *
 * https://piccalil.li/blog/a-modern-css-reset/
 *
 * https://www.joshwcomeau.com/css/custom-css-reset/
 *
 * https://elad2412.github.io/the-new-css-reset/
 *
 * https://meyerweb.com/eric/tools/css/reset/
 *
 * https://github.com/resetercss/reseter.css
 *
 * https://github.com/hankchizljaw/modern-css-reset
 *
 * https://github.com/filipelinhares/ress
 *
 * https://github.com/jgthms/minireset.css
 *
 * https://github.com/necolas/normalize.css
 */ const cssReset = styled.css`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  * {
    margin: 0;
  }

  body,
  html {
    height: 100%;
  }

  body {
    -webkit-font-smoothing: antialiased;
    line-height: 1.5;
    min-height: 100vh;
  }

  html {
    text-size-adjust: 100%;
  }

  html:focus-within {
    scroll-behavior: smooth;
  }

  canvas,
  img,
  picture,
  svg,
  video {
    display: block;
    max-width: 100%;
  }

  button,
  input,
  select,
  textarea {
    font: inherit;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    overflow-wrap: break-word;
  }

  @media (prefers-reduced-motion: reduce) {
    html:focus-within {
      scroll-behavior: auto;
    }
  }
`;

exports.cssReset = cssReset;
//# sourceMappingURL=reset.js.map
